module.exports = __webpack_public_path__ + "static/media/AnkithaB.8ff5fd7d.svg";